import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-container">
        <img
          alt="SETTE Logo"
          className="loader-logo"
          src="../../assets/logo/Logo-Branca.png"
        />
        <div className="loader-ring"></div>
        <div className="loader-ring loader-ring-secondary"></div>
      </div>
    </div>
  );
};

export default Loader;
